module.exports = __webpack_public_path__ + "img/DE00326.4e519f95.png";